import React, { useEffect, Fragment, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackComponent from "../../../components/BackComponent";
import Label from "../../helpers/Label";
import Card from "../../helpers/Card";
import Input from "../../helpers/Input";
import flasher from "@flasher/flasher";
import LinkButton from "../../helpers/LinkButton";
import Loader from "../../Common/Loader";
import Validation from "../../helpers/Validation";
import { ArrowCircleLeft2 } from "iconsax-react";
import CancelButton from "../../helpers/CancelButton";
import SaveButton from "../../helpers/SaveButton";
import { ClearInfo } from "../../../Encapsulation/Utils";
import {  GetHotelLaundry,  SaveHotelLaundry} from "../../../Encapsulation/HotelDomainEntities/HotelLaundry";
import { GetGAAProject } from "../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProject";

function LaundryAddEdit({Rights}) {
  let formMode = "New";
  const { id } = useParams();
  if (id) {
    document.title = "Gladiance - Edit Laundry";
    formMode = "Edit";
  } else {
    document.title = "Gladiance - Add Laundry";
  }
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [formInfo, setFormInfo] = useState({});
  const Navigation = useNavigate();
  const Location = useLocation();

  const handleChange = (e) => {
    setFormInfo((formInfo) => ({
      ...formInfo,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let result = await SaveHotelLaundry(id, formInfo, []);
    if (result.Successful == false) {
      flasher.warning(result.Message);
    } else {
      flasher.success("Data Added Successfully");
      if (formMode == "Edit") {
        Navigation("/laundry");
      } else {
        setFormInfo(ClearInfo(formInfo));
        fetchProject();
      }
    }
  };
  const fetchProject = async () => {
    let Project = await GetGAAProject(Location.state);
    setFormInfo((formInfo) => ({
      ...formInfo,
      GAAProjectRef: Project.Ref,
      GAAProjectName: Project.Name,
    }));
  };

  const fetchLaundry = async () => {
    setFormInfo(await GetHotelLaundry(id));
  };

  useEffect(() => {
    if (Location.state) {
      fetchProject();
    }
    if (id) {
      fetchLaundry();
    }
  }, []);

  return (
    <Fragment>
      {loader ? (
        <Loader />
      ) : (
        <BackComponent
          title={id ? "Edit Laundry" : "Add Laundry"}
          button={
            <LinkButton to={"/laundry"}>
              <ArrowCircleLeft2
                variant="Bold"
                className="w-5 h-5 text-default-color"
              />
            </LinkButton>
          }
        >
          <div className="flex items-center justify-center">
            <Card className={"w-full p-6"}>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-4">
                  <div>
                    <Label
                      htmlFor={"GAAProjectName"}
                      labelText={"Project Name"}
                    />
                    {formInfo.GAAProjectRef && (
                      <Input
                        id={"GAAProjectName"}
                        type={"text"}
                        name={"GAAProjectName"}
                        value={formInfo.GAAProjectName}
                        required={true}
                        readOnly={true}
                      />
                    )}
                  </div>
                  <div>
                    <Label
                      htmlFor={"Name"}
                      labelText={"Name"}
                    />
                    <Input
                      id={"Name"}
                      type={"text"}
                      name={"Name"}
                      value={formInfo.Name}
                      onChange={handleChange}
                      inputFocus={true}
                      readOnly={!Rights.Edit}
                    />
                    <Validation error={errors.Name} />
                  </div>
                  <div>
                    <Label
                      htmlFor={"PressCharges"}
                      labelText={"Press Charges"}
                    />
                    <Input
                      id={"PressCharges"}
                      type={"text"}
                      name={"PressCharges"}
                      value={formInfo.PressCharges}
                      onChange={handleChange}
                      readOnly={!Rights.Edit}
                    />
                    <Validation error={errors.PressCharges} />
                  </div>
                  <div>
                    <Label
                      htmlFor={"DryWashCharges"}
                      labelText={"Dry Wash Charges"}
                    />
                    <Input
                      id={"DryWashCharges"}
                      type={"text"}
                      name={"DryWashCharges"}
                      value={formInfo.DryWashCharges}
                      onChange={handleChange}
                      readOnly={!Rights.Edit}
                    />
                    <Validation error={errors.DryWashCharges} />
                  </div>
                </div>
                <div className="flex gap-8 justify-center mt-6">
                  <CancelButton to={"/laundry"} />
                  {Rights.Edit && <SaveButton text="Save" />}
                </div>
              </form>
            </Card>
          </div>
        </BackComponent>
      )}
    </Fragment>
  );
}

export default LaundryAddEdit;
